<template>
    <div style="background-color: #f5f5f5; height: 100%">
        <div class="pa-5">
            <!-- <h3 class="subheading grey--text">Регистрации</h3> -->
            <div>
                <v-container class="my-5">
                    <span class="crisp" v-for="profile in profiles" :key="profile._id"
                        @click="showEnrolleeList(profile)">
                        {{ profile.fullName }}
                    </span>
                    <v-text-field v-model="query" label="поиск" />
                    <div id="staggered-list-demo"></div>
                    <v-layout v-if="fullList.length" class="mb-3">
                        <v-btn class="mx-1" small text @click="showOnly()">
                            <v-icon small left>mdi-all-inclusive </v-icon>
                            <span class="caption text-lowercase">все</span>
                        </v-btn>
                        <v-btn class="mx-1" small text @click="showOnly('created')">
                            <v-icon small left>mdi-account</v-icon>
                            <span class="caption text-lowercase">создан</span>
                        </v-btn>
                        <v-btn class="mx-1" small text @click="showOnly('confirmation-process')">
                            <v-icon small left>mdi-clock-time-ten-outline </v-icon>
                            <span class="caption text-lowercase">ожидает подтверждения</span>
                        </v-btn>
                        <v-btn class="mx-1" small text @click="showOnly('confirmed')">
                            <v-icon small left>mdi-check-circle-outline</v-icon>
                            <span class="caption text-lowercase">подтвержден</span>
                        </v-btn>
                        <v-btn class="mx-1" small text @click="showOnly('invited')">
                            <v-icon small left>mdi-cake</v-icon>
                            <span class="caption text-lowercase">приглашен</span>
                        </v-btn>
                        <v-btn class="mx-1" small text @click="showOnly('deleted')">
                            <v-icon small left>mdi-delete</v-icon>
                            <span class="caption text-lowercase">удален</span>
                        </v-btn>
                    </v-layout>

                    <!-- <transition-group name="list-item"> -->
                    <div class="d-flex justify-center">
                        <v-progress-circular v-if="loading" indeterminate color="primary" />
                    </div>
                    <Enrollee v-for="user in computedList" :updateEnrolleeList="updateEnrolleeList" :user="user" :key="user._id" />

                    <!-- </transition-group> -->
                </v-container>
            </div>
        </div>
    </div>
</template>
<script>
import axios from "axios";
import Enrollee from "./Enrollee.vue";
export default {
    data() {
        return {
            users: [],
            fullList: [],
            profiles: [],
            query: "",
            loading: false
        };
    },

    components: {
        Enrollee,
    },
    methods: {

        showOnly(status) {
            if (status) return this.users = this.fullList.filter(user => user.status === status)
            this.users = this.fullList
        },
        showEnrolleeList(profile) {
            this.query = ''
            this.users = []
            this.loading = true
            axios
                .get("/api/registries", {
                    params: {
                        profile: profile.enrolleePrefix,
                    },
                })
                .then((res) => {
                    this.users = res.data.users;
                    this.fullList = res.data.users;
                    this.loading = false
                });
        },
        updateEnrolleeList(newEnrol) {
            const { _id } = newEnrol
            this.fullList = this.fullList.map(user => {
                if (user._id == _id) {
                    return { ...newEnrol };
                }
                return user
            })
        }
    },
    created() {
        axios.get("/api/profiles", {}).then((res) => {
            res.data.profileList.unshift({ fullName: 'Все', _id: 1 })
            this.profiles = res.data.profileList;
        });
    },
    computed: {
        computedList: function () {
            var vm = this;
            return this.users.filter(function (item) {
                return (
                    item.surname.toLowerCase().indexOf(vm.query.toLowerCase()) !== -1 || item.name.toLowerCase().indexOf(vm.query.toLowerCase()) !== -1 || item.email.toLowerCase().indexOf(vm.query.toLowerCase()) !== -1 || item.enrolleeId.toLowerCase().indexOf(vm.query.toLowerCase()) !== -1
                );
            });
        },
    },
};
</script>
<style>
.flip-list-move {
    transition: transform 1s;
}

.users.confirmed {
    border-left: 4px solid #4c9c00;
}

.confirmation-process {
    background-color: #cfc203;
}

.theme--light.v-chip.confirmed:not(.v-chip--active) {
    background: #4c9c00;
}

.users.deleted {
    border-left: 4px solid #9c0000;
}

.theme--light.v-chip.deleted:not(.v-chip--active) {
    background: #9c0000;
}

.v-btn.deleted {
    background: #9c0000;
}


.theme--light.v-chip.confirmation-process:not(.v-chip--active) {
    background: #cfc203;
}

.v-btn.confirmation-process {
    background: #cfc203;
}

.theme--light.v-chip.invited:not(.v-chip--active) {
    background: #2196F3;
}

.v-btn.invited {
    background: #2196F3;
}


.crisp {
    display: inline-block;
    border-radius: 20px !important;
    /* background-color: hotpink; */
    padding: 3px;
    /* border: 1px black; */
    padding-left: 10px;
    padding-right: 10px;
    border: 1px solid #bdcfe4;
    margin: 3px;
    cursor: pointer;
    font-size: 13px;
    transition: background-color 0.3s ease-out;
}

.crisp:hover {
    background-color: rgb(255, 255, 255);
}
</style>